export default () => {
  const isOtherCheckbox = $("#incident_report_incident_is_other");
  const isOtherTextField = $("#incident_report_incident_is_other_text");
  const isOtherTextFieldContainer = $(".other-incident-type");

  if (!isOtherCheckbox.is(":checked")) {
    isOtherTextFieldContainer.hide();
  }

  isOtherCheckbox.on("change", () => {
    if (isOtherCheckbox.is(":checked")) {
      isOtherTextFieldContainer.show();
    } else {
      isOtherTextField.val("");
      isOtherTextFieldContainer.hide();
    }
  });
};
